import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// eslint-disable-next-line prettier/prettier
import type { DeleteFileType, DownloadFileType, UploadFileType } from '@/api/types/response/AttachmentType'

/**
 * @property string apiEnd /api/sales/attachment/{bidNumber}
 */
export default class AttachmentApi extends AbstractApi {
  fetch(id: number): Promise<DownloadFileType> {
    return httpClient.get(`${this.apiEnd}/${id}`)
  }

  add(payload: FormData): Promise<UploadFileType> {
    return httpClient.post(this.apiEnd, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  delete(id: number): Promise<DeleteFileType> {
    return httpClient.delete(`${this.apiEnd}/${id}`)
  }
}
